import React from 'react'

const Banners = () => {
  return (
    <div>banners</div>
  )
}

export default Banners